import React, { useEffect, useState } from 'react';
import './AllForLiveCut.scss';
import '../common.scss';
import { IComponentLiveCut } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import BigVideoWrapper from './BigVideoWrapper';

interface IAllForLiveCut extends IComponentLiveCut {
  rootStore?: RootStore;
}

function AllForLiveCut(props: IAllForLiveCut) {
  const theme = useTheme();
  const { title } = props;

  return (
    <div className={'all-for-livecut decoratev2-comp-com'}>
      <div className="row-wrapper">
        {title ? (
          <div className="title" style={{ color: theme.h1Color }}>
            {title}
          </div>
        ) : null}
      </div>
      <BigVideoWrapper {...props}></BigVideoWrapper>
    </div>
  );
}
export default inject('rootStore')(observer(AllForLiveCut));
